import superagent from 'superagent';
import {API_V2_URL} from "./base";

export default class LocationAPI {

  static SendLocationSubscription(location) {
    const URL = `${API_V2_URL}locations/location_subscriptions`;

    return new Promise((resolve, reject) => {

      superagent.post(URL)
        .query({location_subscription: {
                email: location.email,
                latitude: location.latitude,
                longitude: location.longitude,
                street_name: location.street_name,
                street_number: location.street_number,
                city: location.city,
                postal_code: location.postal_code,
                venue_types: "shop"
            }
        })
        .end((error, res) => {
          error ? reject(error) : resolve(res.body);
        });
    });
  }
}
